/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CtmsItemOptionRespVo } from './CtmsItemOptionRespVo';
import {
    CtmsItemOptionRespVoFromJSON,
    CtmsItemOptionRespVoFromJSONTyped,
    CtmsItemOptionRespVoToJSON,
    CtmsItemOptionRespVoToJSONTyped,
} from './CtmsItemOptionRespVo';

/**
 * 
 * @export
 * @interface ResponseListCtmsItemOptionRespVo
 */
export interface ResponseListCtmsItemOptionRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListCtmsItemOptionRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListCtmsItemOptionRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<CtmsItemOptionRespVo>}
     * @memberof ResponseListCtmsItemOptionRespVo
     */
    data?: Array<CtmsItemOptionRespVo>;
}

/**
 * Check if a given object implements the ResponseListCtmsItemOptionRespVo interface.
 */
export function instanceOfResponseListCtmsItemOptionRespVo(value: object): value is ResponseListCtmsItemOptionRespVo {
    return true;
}

export function ResponseListCtmsItemOptionRespVoFromJSON(json: any): ResponseListCtmsItemOptionRespVo {
    return ResponseListCtmsItemOptionRespVoFromJSONTyped(json, false);
}

export function ResponseListCtmsItemOptionRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListCtmsItemOptionRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(CtmsItemOptionRespVoFromJSON)),
    };
}

export function ResponseListCtmsItemOptionRespVoToJSON(json: any): ResponseListCtmsItemOptionRespVo {
    return ResponseListCtmsItemOptionRespVoToJSONTyped(json, false);
}

export function ResponseListCtmsItemOptionRespVoToJSONTyped(value?: ResponseListCtmsItemOptionRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(CtmsItemOptionRespVoToJSON)),
    };
}

